const dateFormat = new Intl.DateTimeFormat("en-AU", {
  day: "numeric",
  month: "short",
  year: "numeric",
});
const timeFormat = new Intl.DateTimeFormat("en-AU", { hour: "numeric", minute: "2-digit" });

/** "Just now", "5 min ago", "3:42 pm", or "19 Oct 2026". */
export const formatRelative = (iso: string, now = new Date()): string => {
  const date = new Date(iso);
  const minutes = Math.round((now.getTime() - date.getTime()) / 60_000);
  if (minutes < 1) return "Just now";
  if (minutes < 60) return `${minutes} min ago`;
  if (date.toDateString() === now.toDateString()) return timeFormat.format(date);
  return dateFormat.format(date);
};

export const formatDate = (iso: string) => dateFormat.format(new Date(iso));
